<template>
  <el-select v-model="selectedValue" v-bind="$attrs" v-on="$listeners" :filter-method="filterEvent" @change="change">
    <el-option v-for="item in renderOptions" :key="item[props.value]" :label="item[props.label]"
      :value="item[props.value]">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'yblSingleSelect',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    selected: {
      type: String | Number,
      default: () => ''
    },
    props: {
      type: Object,
      default: function () {
        return { label: 'label', value: 'value' }
      }
    },
    size: { // 默认显示条数
      type: Number | String,
      default: () => 20
    }
  },
  data () {
    return {
      originOptions: [],
      renderOptions: [],
      selectedValue: ''
    }
  },
  created () {
    if (this.options) {
      this.originOptions = [...this.options]
      this.initOptions()
    }
    this.selectedValue = this.selected
  },
  methods: {
    initOptions () {
      this.renderOptions = this.originOptions.filter((item, index) => index < +this.size)
      if (this.selected) {
        const key = this.props['value']
        const isExist = this.renderOptions.filter(item => `${item[key]}` === `${this.selected}`)
        if (isExist && isExist.length > 0) {
          return
        }
        const selectOptions = this.originOptions.filter(item => `${item[key]}` === `${this.selected}`)
        this.renderOptions = [...selectOptions, ...this.renderOptions]
      }
    },
    filterEvent (val) {
      if (val) {
        const label = this.props.label
        this.renderOptions = this.originOptions.filter(item => `${item[label]}`.includes(val))
      } else {
        this.initOptions()
      }
    },
    change (val) {
      const item = this.originOptions.find(item => `${item[this.props.value]}` === `${val}`)
      this.$emit('refresh', val, item)
    }
  },
  watch: {
    'options': function (newVal, oldVal) {
      this.originOptions = [...newVal]
      this.initOptions()
    },
    'selected': function (newVal, oldVal) {
      this.selectedValue = newVal
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SingleSelect.vue